<template>
  <div class="brands-teaser">
    <div
      v-if="headline"
      class="brands-teaser__headline | headline headline--type_teaser"
    >
      {{ headline }}
    </div>
    <carousel
      class="brands-teaser__carousel"
      v-if="brands"
      :slides-count="brands.length"
      :slides-per-view-desktop="7"
      :slides-per-view-mobile="5"
      :slides-per-view-tablet="2"
    >
      <template
        v-for="(brand, index) in brands"
        :key="index"
        #[slotName(index)]
      >
        <brand-tile v-bind="brand" />
      </template>
    </carousel>
    <brands-tiles-teaser
      class="brands-teaser__additional-brands"
      :initial-brands="additionalBrands"
    />
  </div>
</template>
<script>
  import Carousel from '../carousel/carousel.vue';
  import BrandTile from '../brandTile/brandTile.vue';
  import BrandsTilesTeaser from '../brandsTilesTeaser/brandsTilesTeaser.vue';

  export default {
    components: {
      Carousel,
      BrandTile,
      BrandsTilesTeaser
    },
    props: {
      headline: String,
      additionalBrands: {
        type: Array,
        default() {
          return [];
        }
      },
      topBrands: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        brands: this.topBrands
      }
    },
    methods: {
      slotName(index) {
        return `slide-${index + 1}`
      },
    },
  };

</script>
